import { Box } from "@mui/material";
import { MprcIconButton } from "components";
import { IconUserRestriction } from "components/icons";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { PermissionConstraintDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserPanelRestrictionsDrawer } from "views/dashboard/drawers/UserPanelRestrictionsDrawer";

interface IProps {
    permissionId: string;
}

export const DashUserRestrictionAction = ({ permissionId }: IProps) => {
    const { t } = useTranslation("dashboard");
    const [dialog, setDialog] = useState<React.ReactNode>();
    const [loading, setLoading] = useState(true);
    const [viewData, setViewData] = useState<PermissionConstraintDto | null>(null);

    const api = useCoreApi();

    useEffect(() => {
        async function getData() {
            try {
                var result = await api.v1.user.userPermissionConstraintQuery({ permissionId });
                setViewData(result.data);
            }
            catch (e) {
                MprcRequestSnackbarErrorReport(e);
            }
            finally {
                setLoading(false);
            }
        }
        if (loading) getData();

    }, [loading]);

    return !loading && viewData?.global !== true && (
        <Box>
            {dialog}

            <MprcIconButton
                title={t("Common.Filter.UserRestrictionTooltip")}
                disabled={loading}
                color="warning"
                onClick={() => {
                    setDialog(<UserPanelRestrictionsDrawer
                        data={viewData}
                        onClose={() => setDialog(null)}
                    />);
                }}
            >
                <IconUserRestriction fixedWidth />
            </MprcIconButton>
        </Box>
    );
};
